import {
    type InformationActionType,
    type InformationState,
} from "../../Actions/Information/InformationActions";
import {
    DATABASE_BLOCKED,
    INFORMATION_FIRST_VIEW,
    INFORMATION_OFFLINE,
    INFORMATION_ONLINE,
    INFORMATION_SET_TRAINING,
} from "../../Actions/Information/InformationConstants";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";
import { getURLQuery } from "../../Utilities/Platform/CurrentRequest";
import { getOption, isTrainingMode } from "../../Utilities/Platform/Options/Options";

function InformationReducer(
    state: InformationState,
    action: ShopfrontActions<InformationActionType>
): InformationState {
    if(typeof state === "undefined") {
        let firstVisit = true;

        if(process.env.NODE_ENV !== "production") {
            try {
                if((getURLQuery(true) as any).bypass_first_login === true) {
                    firstVisit = false;
                }
            } catch {
                // Do nothing
            }
        }

        return {
            online         : true,
            training       : isTrainingMode(),
            firstVisit     : firstVisit,
            databaseBlocked: {
                blocked: false,
                certain: true,
            },
        };
    }

    switch(action.type) {
        case INFORMATION_ONLINE:
            return {
                ...state,
                online: true,
            };
        case INFORMATION_OFFLINE:
            return {
                ...state,
                online: false,
            };
        case INFORMATION_FIRST_VIEW:
            return {
                ...state,
                firstVisit: false,
            };
        case INFORMATION_SET_TRAINING:
            return {
                ...state,
                training: action.data && getOption("register_training_sales_mode_enabled"),
            };
        case DATABASE_BLOCKED:
            return {
                ...state,
                databaseBlocked: {
                    blocked: true,
                    certain: action.certain,
                },
            };
        default:
            return state;
    }
}

export default InformationReducer;
